export default __webpack_public_path__ + "static/media/cal_icon.3bb83e93.png";